<template>
    <div class="slide">
        <LoadingDots v-show="loading" />
        <CategoryMenu
            v-for="theme in themes"
            :key="theme.id"
            :category="theme"
            :selected="selected"
            class="category--theme"
            :opened="
                theme.objects.some((s) =>
                    s.osmdiff.some((o) => activeObject && activeObject.id === o.id),
                )
            "
        >
            <Icon slot="title" v-if="theme.icon" :icon="theme.icon" :color="theme.color" />

            <CategoryMenu
                v-for="object in theme.objects"
                :key="object.id"
                :category="object"
                :selected="selected"
                class="category--object"
                :opened="object.osmdiff.some((o) => activeObject && activeObject.id === o.id)"
            >
                <div
                    v-for="osm in object.osmdiff"
                    :key="osm.id"
                    class="osm-object"
                    :class="{ 'display--object': activeObject && activeObject.id === osm.id }"
                    @click.self="
                        displayObject(
                            osm,
                            theme.color,
                            VerifGeom(object),
                            VerifAllTags(object),
                            object.rights
                                .reduce((a, r) => [].concat(a, r.keys), [])
                                .map((k) => k.name),
                        )
                    "
                >
                    <Checkbox v-model="selected" :id="osm.id" :val="osm" />
                    {{ osm.name || osm.id }}
                    <div
                        class="osm--actions"
                        :class="{ active: selected.some((s) => s.id === osm.id) }"
                    >
                        <font-awesome-icon
                            title="Valider"
                            icon="check"
                            class="actions--icon-accept"
                            @click="$emit('osm-objects:accept')"
                        />
                        <font-awesome-icon
                            title="Mettre en attente"
                            icon="clock"
                            class="inverse actions--icon-waiting"
                            @click="$emit('osm-objects:waiting')"
                        />
                        <font-awesome-icon
                            title="Rejeter"
                            icon="pen"
                            class="actions--icon-reject"
                            @click="$emit('osm-objects:reject')"
                        />
                    </div>
                </div>
            </CategoryMenu>
        </CategoryMenu>
    </div>
</template>

<script>
import LoadingDots from './LoadingDots';
import CategoryMenu from './CategoryMenu';
import Icon from './Icon';
import Checkbox from '@/components/Checkbox';

export default {
    props: {
        themes: Array,
        loading: Boolean,
        activeObject: Object,
        value: Array,
    },
    data() {
        return {
            selected: this.value || [],
        };
    },
    watch: {
        value: function() {
            this.selected = this.value;
        },
        selected: function() {
            this.$emit('input', this.selected);
        },
    },
    methods: {
        displayObject: function(object, color, checkGeom, checkAllKeys, keys) {
            this.$emit('display:object', {
                object,
                color,
                checkGeom,
                checkAllKeys,
                keys,
            });
        },
        VerifAllTags: function(object) {
            let result = false;
            if (object.rights.length) {
                const verif_all_tags = object.rights.reduce(
                    (a, r) => [].concat(a, r.r_verif_all_tags),
                    [],
                );
                if (verif_all_tags.includes(true)) {
                    result = true;
                }
            }
            return result;
        },
        VerifGeom: function(object) {
            let result = false;
            if (object.rights.length) {
                const verif_geom = object.rights.reduce((a, r) => [].concat(a, r.r_verif_geom), []);
                if (verif_geom.includes(true)) {
                    result = true;
                }
            }
            return result;
        },
    },
    components: {
        LoadingDots,
        CategoryMenu,
        Icon,
        Checkbox,
    },
};
</script>

<style lang="scss">
.category--theme {
    .category-title-button {
        padding: 8px 0px 8px 0px;
        background-color: #f6f7f8;

        &:hover {
            background-color: #ebedef;
        }
    }
}

.category--object {
    .category-title-button {
        padding: 6px 0px 6px 14px;
        background-color: #ffffff;

        &:hover {
            background-color: #f9f9fa;
        }
    }
}

.osm-object {
    cursor: pointer;
    color: #9ca5b0;
    font-size: 13px;
    line-height: 18px;
    padding: 6px 18px 6px 45px;
    // border-left: none;
    position: relative;

    &:hover {
        background-color: #f9f9fa;

        .osm--actions.active {
            display: block;
        }
    }

    &.display--object {
        color: #6c3e91;
        font-size: 13px;
        font-weight: 600;
        padding-left: 42px;
        border-left: 3px solid #6c3e91;
    }

    .osm--actions {
        display: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1px;
        box-shadow: -5px 0 4px 2px rgba(255, 255, 255, 0.43);
        background-color: #fafafa;
        padding: 6px;

        .actions--icon-accept {
            color: #93c11f;
            // background-color: #93c11f;
            // border-radius: 3px;
            // padding: 5px;
            margin-right: 6px;
        }

        .actions--icon-waiting {
            color: #6c3e91;
            // background-color: #6c3e91;
            // border-radius: 3px;
            // padding: 5px;
            margin-right: 6px;
        }

        .actions--icon-reject {
            color: #ea5b0c;
            // background-color: #ea5b0c;
            // border-radius: 3px;
            // padding: 5px;
            // margin-right: 5px;
        }
    }
}
</style>
